export default __webpack_public_path__ + "806bf87b79d1d483808c677af7587e8e.woff2";